import './WhatAreYouLookingFor.css';
import WhatAreYouLookingForToggleButton from './WhatAreYouLookingForToggleButton';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import eventEnable from '../core/eventEnable';
import exposeBinding from '../mvvm/exposeBinding';
export default class WhatAreYouLookingForFeatures{
	constructor({siteJsons, whatAreYouLookingForViewModel}){
		eventEnable(this);
		this._whatAreYouLookingForViewModel = whatAreYouLookingForViewModel;
		this._element = document.createElement('div');
		this._element.classList.add('features');
		this._createSetFeaturesButton= this._createSetFeaturesButton.bind(this);
		this._removeFeaturesButton= this._removeFeaturesButton.bind(this);
		this._featuresChanged= this._featuresChanged.bind(this);
		this._selectedFeaturesChanged= this._selectedFeaturesChanged.bind(this);
		this._get_setFeature= this._get_setFeature.bind(this);
		this._featuresAvailableWithOtherOptionsChanged= this._featuresAvailableWithOtherOptionsChanged.bind(this);
		this._mapFeatureIdToButton = new Map();
		this._toggleButtons=[];
		this._propertyBindingFeatures = PropertyBindingFactory.standard(this, 
			siteJsons, 'allFeatures', this._featuresChanged);
		this._propertyBindingSelectedFeatures = PropertyBindingFactory.standard(this, 
			whatAreYouLookingForViewModel, 'features', this._selectedFeaturesChanged);
		this._propertyBindingFeaturesAvailableWithOtherOptions = PropertyBindingFactory.standard(this, 
			whatAreYouLookingForViewModel, 'featuresAvailableWithOtherOptions', this._featuresAvailableWithOtherOptionsChanged);
	}
	_featuresChanged(features){
		const seenIds = [];
		features?.forEach(feature=>{
			seenIds.push(feature.id);
			let toggleButton = this._mapFeatureIdToButton.get(feature.id);
			if(!toggleButton)this._createSetFeaturesButton(feature);
		});
		Array.from(this._mapFeatureIdToButton.keys()).forEach(featureId=>{
			if(seenIds.indexOf(featureId)>=0)return;
			this._removeFeaturesButton(featureId);
		});
	}
	_featuresAvailableWithOtherOptionsChanged(value){
		if(!value)return;
		const availableFeatureIds = value?.map(feature=>feature.id);
		this._toggleButtons.forEach(toggleButton=>{
			const featureId = toggleButton.value;
			const isAvailableOption = (!availableFeatureIds)||availableFeatureIds.indexOf(featureId)>=0;
			toggleButton.setAvailableOption(isAvailableOption);
		});
	}
	_removeFeaturesButton(featureId){	
		const toggleButton = this._mapFeatureIdToButton.get(featureId);
		this._element.appendChild(toggleButton.element);
		this._mapFeatureIdToButton.delete(featureId);
		this._toggleButtons.splice(this._toggleButtons.indexOf(toggleButton), 1);
	}
	_selectedFeaturesChanged(value){
		if(!value)return;
		if(value.length<1)return;
		this._toggleButtons.forEach(toggleButton=>toggleButton.unselect());
		value.forEach(feature=>{
			this._mapFeatureIdToButton.get(feature.id).select();
		});
	}
	_createSetFeaturesButton(feature){
		const toggleButton = new WhatAreYouLookingForToggleButton({
			callbackClicked:this._get_setFeature(feature),
			text:feature.name,
			value:feature.id
		});
		this._mapFeatureIdToButton.set(feature.id, toggleButton);
		this._element.appendChild(toggleButton.element);
		this._toggleButtons.push(toggleButton);
	}
	_get_setFeature(feature){
		return (toggleButton)=>{
			if(toggleButton.selected){
				toggleButton.unselect();
				this._propertyBindingSelectedFeatures.set(null);
				return;
			}
			this._propertyBindingSelectedFeatures.set([feature]);
			this.dispatchEvent({type:'chose'});
		};
	}
	get element(){
		return this._element;
	}
}